import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuItem, menuItems } from '../menuConfig';

/**
 * Обновляет активное состояние элементов меню на основе текущего пути
 * Сначала сбрасывает все активные состояния, затем устанавливает активные для текущего пути
 */
const updateActiveMenuItems = (items: MenuItem[], currentPath: string): MenuItem[] => {
    return items.map(item => {
        // Проверяем, есть ли активный дочерний элемент
        const hasActiveChild = item.children?.some(child => child.link === currentPath);
        // Элемент активен, если его путь совпадает с текущим, или если он primary и имеет активного ребенка
        const isActive = (item.link === currentPath) || (hasActiveChild && item.isPrimary);
        
        return {
            ...item,
            isActive: isActive || false,
            children: item.children?.map(child => ({
                ...child,
                isActive: child.link === currentPath || false
            }))
        };
    });
};

/**
 * Хук для управления состоянием элементов меню
 */
export const useMenuItems = () => {
    const location = useLocation();
    const [menuItemsState, setMenuItemsState] = useState<MenuItem[]>(() => 
        updateActiveMenuItems(menuItems, location.pathname)
    );

    useEffect(() => {
        const frameId = requestAnimationFrame(() => {
            const updated = updateActiveMenuItems(menuItems, location.pathname);
            setMenuItemsState(updated);
        });

        return () => cancelAnimationFrame(frameId);
    }, [location.pathname]);

    return menuItemsState;
};

